import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef
} from 'react';
import * as dayjs from 'dayjs';
import { Button } from 'devextreme-react';
import Drawer from 'devextreme-react/drawer';
import { Template } from 'devextreme-react/core/template';
import Form, {
  SimpleItem,
  RequiredRule,
  GroupItem,
  ButtonItem,
  Item
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import DataGrid, {
  Selection,
  Paging,
  FilterRow,
  Scrolling,
  Column
} from 'devextreme-react/data-grid';
import {
  Chart,
  Series,
  CommonSeriesSettings,
  ConstantLine,
  Label,
  Legend,
  Export,
  ValueAxis
} from 'devextreme-react/chart';
import DropDownBox from 'devextreme-react/drop-down-box';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { format } from 'date-fns';
import PopupMVP from '../../PopupMVP';
import style from './acceptancemetric.module.scss';

const cursor = {};

function compare(a, b) {
  if (dayjs(a.state).diff(dayjs(b.state)) > 0) {
    return -1;
  }
  if (dayjs(a.state).diff(dayjs(b.state)) < 0) {
    return 1;
  }
  return 0;
}

// eslint-disable-next-line no-shadow
function dataOneMonth(listData, format = 'YYYY-MM-DD') {
  const temp = [];
  const tempName = new Set();
  const tempDop = [];
  const avgTime = [];

  listData.forEach((item) => {
    if (item) {
      const date = item.date1 > item.date2 ? item.date1 : item.date2;
      tempName.add(item.plantDescription);
      temp[dayjs(date).format(format)] = {
        ...temp[dayjs(date).format(format)],
        [item.plantDescription]: {
          sumWeight: item.weight + (
            temp[dayjs(date).format(format)]
            && temp[dayjs(date).format(format)][item.plantDescription]
            && temp[dayjs(date).format(format)][item.plantDescription].sumWeight
              ? temp[dayjs(date).format(format)][item.plantDescription].sumWeight
              : 0
          ),
          sum: Math.abs(item.hoursWW) * item.weight + (
            temp[dayjs(date).format(format)]
            && temp[dayjs(date).format(format)][item.plantDescription]
            && temp[dayjs(date).format(format)][item.plantDescription].sum
              ? temp[dayjs(date).format(format)][item.plantDescription].sum
              : 0
          ),
          name: item.plantDescription,
          docNumIds: `${item.docNumId},${temp[dayjs(date).format(format)]
          && temp[dayjs(date).format(format)][item.plantDescription]
          && temp[dayjs(date).format(format)][item.plantDescription].docNumIds
            ? temp[dayjs(date).format(format)][item.plantDescription].docNumIds
            : ''}`
        }
      };
    }
  });
  // eslint-disable-next-line no-restricted-syntax
  for (const i of Object.keys(temp)) {
    let tempObj = { state: i };
    // eslint-disable-next-line no-restricted-syntax
    for (const j of Object.keys(temp[i])) {
      tempObj = {
        ...tempObj,
        [j]: temp[i][j].sum / temp[i][j].sumWeight
      };
    }
    tempDop.push(tempObj);
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const i of Object.keys(tempDop)) {
    // eslint-disable-next-line no-plusplus
    for (let j = 1; j < Object.keys(tempDop[i]).length; j++) {
      let tempObj = {};
      tempObj = {
        name: Object.keys(tempDop[i])[j],
        value: Object.values(tempDop[i])[j]
      };
      avgTime.push(tempObj);
    }
  }
  const tempAvgObj = avgTime.reduce((acc, record) => {
    const { name, value } = record;

    if (!acc[name]) {
      acc[name] = { value: 0, count: 0 };
    }
    acc[name].value += value;
    acc[name].count += 1;
    return acc;
  }, {});

  return {
    temp: tempDop.sort(compare),
    tempName: Array.from(tempName),
    tempAvgObj,
    tempItems: temp
  };
}

const AcceptanceMetric = ({
  metricReducer: {
    listTypes,
    listData
  },
  reportReducer: {
    error,
    okRequest,
    loading
  },
  stockReducer: { listStocks },
  metricPieceTypesList,
  metricPieceData,
  getReportCreateNew,
  getReportErrorClose,
  modalErrorOpen
}) => {
  const form = useRef(null);
  const [visibleDrawer, setVisibleDrawer] = useState(true);
  const [plantIds, setPlantIds] = useState([]);
  const [data, setData] = useState({});

  const [dataSourceMetric, setDataSourceMetric] = useState([]);
  const [nameSeries, setNameSeries] = useState([]);
  const [avgObj, setAvgObj] = useState({});
  const [itemsMetric, setItemsMetric] = useState({ items: [] });

  const [dopDataMetric, setDopDataMetric] = useState({
    data: [],
    series: [],
    items: []
  });
  const [redLine, setRedLine] = useState(null);
  useEffect(() => {
    metricPieceTypesList();
  }, [metricPieceTypesList]);
  const [pointData, setPointData] = useState({});
  const [visiblePopup, setVisiblePopup] = useState(false);

  /** Алгоритм обработки данных */
  useEffect(() => {
    if (listData && listData.length) {
      const diffMonth = dayjs(data.dateTo).diff(data.dateFrom, 'month', true);

      if (diffMonth <= 1) {
        const { temp, tempName, tempAvgObj, tempItems } = dataOneMonth(listData);
        setDataSourceMetric(temp);
        setNameSeries(tempName);
        setAvgObj(tempAvgObj);
        setItemsMetric({ tempItems });
      } else {
        const { temp, tempName, tempAvgObj } = dataOneMonth(listData, 'YYYY-MM');
        setDataSourceMetric(temp);
        setNameSeries(tempName);
        setAvgObj(tempAvgObj);
      }
    }
  }, [data, listData]);

  /** Действие на сабмит */
  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    // eslint-disable-next-line default-case
    switch (cursor.metrics) {
      case 1: setRedLine(24); break;
      case 4: setRedLine(24); break;
      case 5: setRedLine(72); break;
    }
    metricPieceData({
      metricId: cursor.metrics,
      dateFrom: cursor.dateFrom,
      dateTo: cursor.dateTo,
      plantIds: cursor.plantIds
    });
    setData({
      dateFrom: cursor.dateFrom,
      dateTo: cursor.dateTo,
      title: listTypes.filter((item) => item.code === cursor.metrics)[0].description
    });
    setDopDataMetric({
      data: [],
      series: [],
      items: []
    });
  }, [listTypes, metricPieceData]);

  /** Если ошибка, то выводить в модальном окне */
  useEffect(() => {
    if (error) {
      modalErrorOpen({
        message: error.message,
        techInfo: error.techInfo,
        types: 'error',
        title: formatMessage('error')
      });
      getReportErrorClose();
    }
  }, [error, getReportErrorClose, modalErrorOpen]);

  /** При успешной выгрузке скрыть модальное окно */
  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('textReportSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      getReportErrorClose();
      setVisiblePopup(false);
    }
  }, [getReportErrorClose, okRequest]);

  /** Скрыть модальное окно */
  const modalOnHiding = useCallback(() => {
    setVisiblePopup(false);
  }, []);

  /** Представление на выпадающий список метрик */
  const renderSelectBoxTemplate = useMemo(() => (
    <Template name="dxSelectBoxMetricType"
              render={(value) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                     title={`${value.code}: ${value.description}`}
                >
                  {`${value.code}: ${value.description}`}
                </div>
              )}
    />
  ), []);

  /** Рендер содержимого выпадающего списка складов */
  const renderDataGridPlant = useMemo(() => () => (
    <DataGrid hoverStateEnabled
              dataSource={listStocks}
              height="300px"
              keyExpr="plantId"
              selectedRowKeys={plantIds}
              onSelectionChanged={(e) => {
                // eslint-disable-next-line no-mixed-operators
                const result = e.selectedRowKeys.length && e.selectedRowKeys || [];
                cursor.plantIds = result;
                setPlantIds(result);
              }}
    >
      <Column dataField="plantId"
              caption="ID склада"
              width={100}
      />
      <Column dataField="plantShortDescr"
              caption="Название"
      />
      <Selection mode="multiple" />
      <Scrolling mode="virtual" />
      <Paging enabled pageSize={10} />
      <FilterRow visible />
    </DataGrid>
  ), [listStocks, plantIds]);

  /** Рендер формы выпадающего списка складов */
  const renderDrawBox = useMemo(() => (
    <DropDownBox showClearButton
                 stylingMode="filled"
                 valueExpr="plantId"
                 displayExpr="displayExpr"
                 dataSource={listStocks}
                 deferRendering={false}
                 dropDownOptions={{ minWidth: '600px' }}
                 contentRender={renderDataGridPlant}
                 value={plantIds}
                 onValueChanged={(e) => setPlantIds(e.value || [])}
    />
  ), [listStocks, plantIds, renderDataGridPlant]);

  /** Рендер панели фильтров */
  const RenderLeftDrawer = useMemo(() => () => (
    <div className={style.form}>
      <form method="POST"
            onSubmit={formOnSubmit}
      >
        <Form labelLocation="top"
              width="100%"
              readOnly={false}
              showColonAfterLabel
              showValidationSummary={false}
              formData={cursor}
              ref={form}
        >
          <GroupItem>
            <SimpleItem dataField="dateFrom"
                        editorType="dxDateBox"
                        label={{ text: 'Дата с' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <SimpleItem dataField="dateTo"
                        editorType="dxDateBox"
                        label={{ text: 'Дата по' }}
                        editorOptions={{
                          stylingMode: 'filled',
                          dateSerializationFormat: 'yyyy-MM-dd'
                        }}
            >
              <RequiredRule message="Выберите значение" />
            </SimpleItem>
            <SimpleItem dataField="metrics"
                        editorType="dxSelectBox"
                        label={{ text: 'Метрика' }}
                        editorOptions={{
                          showClearButton: true,
                          stylingMode: 'filled',
                          dataSource: listTypes,
                          valueExpr: 'code',
                          itemTemplate: 'dxSelectBoxMetricType',
                          displayExpr: (item) => item && `${item.code}: ${item.description}`,
                          dropDownOptions: { minWidth: '300px' }
                        }}
            >
              <RequiredRule message="Выберите значение" />
              { renderSelectBoxTemplate }
            </SimpleItem>
            <Item dataField="plantIds"
                  editorType="dxDropDownBox"
                  label={{ text: 'Склад' }}
            >
              { renderDrawBox }
              <RequiredRule message="Выберите значение" />
            </Item>
            <ButtonItem horizontalAlignment="right"
                        buttonOptions={{
                          text: 'Построить',
                          type: 'default',
                          useSubmitBehavior: true
                        }}
            />
          </GroupItem>
        </Form>
      </form>
    </div>
  ), [
    formOnSubmit,
    listTypes,
    renderSelectBoxTemplate,
    renderDrawBox
  ]);

  /** Клик на bar */
  const onPointClick = useCallback(({ target: point }) => {
    // console.debug(
    //   point.data,
    //   dayjs(point.data.state).startOf('month'),
    //   dayjs(point.data.state).endOf('month'),
    //   dayjs(point.data.state).startOf('month') > dayjs(point.data.state).endOf('month'),
    //   point.argument,
    //   point.series.name.substring(0, point.series.name.indexOf('<br>')).trim()
    // );
    const diffMonth = dayjs(data.dateTo).diff(data.dateFrom, 'month', true);
    if (diffMonth > 1) {
      const tempListData = listData.filter((item) => {
        if (item) {
          const date = item.date1 > item.date2 ? item.date1 : item.date2;
          if (
            dayjs(point.data.state).startOf('month') <= dayjs(date)
            && dayjs(point.data.state).endOf('month') >= dayjs(date)
          ) {
            return true;
          }
        }
        return false;
      });
      const { temp, tempName, tempItems } = dataOneMonth(tempListData);
      setDopDataMetric({
        data: temp,
        series: tempName,
        items: tempItems
      });
    } else {
      setDopDataMetric({
        data: [],
        series: [],
        items: []
      });
      if (cursor.metrics !== 3) {
        setPointData({
          date: point.argument,
          plantDescription: point.series.name.substring(0, point.series.name.indexOf('<br>')).trim()
        });
        setVisiblePopup(true);
      }
    }
  }, [data, listData]);

  /** Клик на bar дополнительного графика */
  const onPointClickDop = useCallback(({ target: point }) => {
    if (cursor.metrics !== 3) {
      setPointData({
        date: point.argument,
        plantDescription: point.series.name
      });
      setVisiblePopup(true);
    }
  }, []);

  /** Вызов в Saga функции для отправки в бэк данных для печатной формы */
  const onReportCreate = useCallback(() => {
    // eslint-disable-next-line max-len
    const { plantId } = listData.filter((item) => item !== null && item.plantDescription === pointData.plantDescription)[0];
    getReportCreateNew({
      reportType: 'METRIC_ON_STOCK',
      printFormat: 'PDF',
      reportParams: {
        docNumIds: [...new Set((Object.keys(dopDataMetric.items).length > 0
          ? dopDataMetric.items[pointData.date][pointData.plantDescription].docNumIds.split(',').map(Number)
          : itemsMetric.tempItems[pointData.date][pointData.plantDescription].docNumIds.split(',').map(Number)))],
        metricId: cursor.metrics,
        plantId,
        dateMetric: format(new Date(pointData.date), 'yyyy-MM-dd')
      }
    });
  }, [pointData, listData, getReportCreateNew, dopDataMetric, itemsMetric]);

  /** Рендер основного графика метрик */
  const renderMain = useMemo(
    (x) => (
      <div className={style.data}>
        <Chart
          id="chart"
          palette="Soft"
          title={data.title}
          dataSource={dataSourceMetric}
          elementAttr={{ class: style.chart }}
          onPointClick={onPointClick}
        >
          <CommonSeriesSettings
            argumentField="state"
            type="bar"
            ignoreEmptyPoints
          />
          <ValueAxis>
            <ConstantLine
              width={2}
              value={redLine}
              color="red"
              dashStyle="solid"
            >
              {/* eslint-disable-next-line no-template-curly-in-string */}
              <Label text={`Норматив ${redLine} ч.`} />
            </ConstantLine>
          </ValueAxis>
          {nameSeries.map((item) => (
            <Series
              key={item}
              valueField={item}
            // eslint-disable-next-line
              name={(typeof avgObj[item] !== 'undefined') ?
                `${item} <br> ~${(Math.round(((avgObj[item].value) / ((!avgObj[item].count || avgObj[item].count === 0) ? 1 : avgObj[item].count)), 1))} ч.`
                : `${item} <br> 0 ч.`}
            />
          ))}
          <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          <Export enabled />
        </Chart>
      </div>
    ),
    [data, dataSourceMetric, nameSeries, onPointClick, redLine, avgObj]
  );

  /** Рендер дополнительного графика метрик */
  const renderDopMetric = useMemo(() => {
    if (dopDataMetric.data.length) {
      return (
        <div className={style.data}>
          <Chart
            id="chart"
            palette="Soft"
            title=""
            dataSource={dopDataMetric.data}
            elementAttr={{ class: style.chart }}
            onPointClick={onPointClickDop}
          >
            <CommonSeriesSettings
              argumentField="state"
              type="bar"
              ignoreEmptyPoints
            />
            <ValueAxis>
              <ConstantLine
                width={2}
                value={redLine}
                color="red"
                dashStyle="solid"
              >
                {/* eslint-disable-next-line no-template-curly-in-string */}
                <Label text={`Норматив ${redLine} ч.`} />
              </ConstantLine>
            </ValueAxis>
            {
              dopDataMetric.series.map((item) => (
                <Series key={item} valueField={item} name={item} />
              ))
            }
            <Legend verticalAlignment="bottom" horizontalAlignment="center" />
            <Export enabled />
          </Chart>
        </div>
      );
    }
    return null;
  },
  [dopDataMetric.data, dopDataMetric.series, redLine, onPointClickDop]);

  /** Рисование формы метрик с содержимым */
  const renderContend = useMemo(() => {
    if (listData === null) {
      return (
        <div className={style.text}>Выберите данные для построения метрики</div>
      );
    }
    if (listData.length && avgObj) {
      return (
        <>
          {renderMain}
          {renderDopMetric}
        </>
      );
    }
    return (
      <div className={style.text}>Нет данных для отображения</div>
    );
  }, [listData, renderMain, renderDopMetric, avgObj]);

  return (
    <div className={style.container}>
      <Drawer opened={visibleDrawer}
              elementAttr={{ class: style.drawer }}
              component={RenderLeftDrawer}
              position="left"
              revealMode="slide"
              openedStateMode="shrink"
      >
        <div className={style.main}>
          <Button elementAttr={{ class: style.buttonDrawer }}
                  stylingMode={'text'}
                  icon={!visibleDrawer ? 'filter' : 'arrowleft'}
                  type="normal"
                  onClick={() => setVisibleDrawer((current) => !current)}
          />
          { renderContend }
        </div>
      </Drawer>
      <PopupMVP visible={visiblePopup}
                onHiding={modalOnHiding}
                title={formatMessage('textModal').exportPDF}
                className={style.modalDop}
      >
        <div className="formData">
          <div className="formButton">
            <Button text={formatMessage('textButton').cancel}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
            <Button type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={() => onReportCreate()}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').export}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
    </div>
  );
};

export default AcceptanceMetric;
